import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import Web3 from 'web3';
import axios from 'axios';

function Tasksetting() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [assets, setAssets] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [assetId, setAssetId] = useState("");
  const web3 = new Web3("https://bsc-dataseed.binance.org/");

  

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };





  useEffect(() => {

    fetchAssets(1);
  }, []);

  const handleProfileDataFetched = (data) => {
    setProfileData(data.USER);
    setMasterData(data.MASTERDATA);
  };


  const fetchAssets = async (page) => {
    try {
      const searchData = {
        page: page,
      };

      const response = await axios.post(
        `${baseurl}/task-setting`,
        searchData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          validateStatus: (status) => status < 500 // Prevent throwing for 4xx
        }
      );

      if (response.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return;
      }

      const depositResult = response.data;
      console.log('Static data', depositResult);

      if (depositResult.status) {
        setAnalytics(depositResult.taskCount);
        setAssets(depositResult.data);
        setPagination(depositResult.pagination);
        setTableLoading(true);
      } else {
        setTableLoading(true); // Optionally show message
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };


  const handlePageChange = async (page) => {

    setTableLoading(false)
    fetchAssets(page);
  }




  const [rankName, setRankName] = useState("");
  const [fromAmount, setFromAmount] = useState(0);
  const [toAmount, setToAmount] = useState(0);
  const [downline, setDownline] = useState(0);
  const [dailyTask, setDailyTask] = useState("");
  const [dailyProfit, setDailyProfit] = useState("");
  const [showPercentage, setShowPercentage] = useState("");
  const [uplineBonus, setUploneBonus] = useState("");
  const [comunityBonus, setCommunityBonus] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);


const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  formData.append('name', rankName);
  formData.append('required_from_balance', fromAmount);
  formData.append('required_to_balance', toAmount);
  formData.append('required_downline', downline);
  formData.append('daily_task', dailyTask);
  formData.append('daily_profit_percentage', dailyProfit);
  formData.append('daily_percentage_show', showPercentage);
  formData.append('upline_bonus', uplineBonus);
  formData.append('community_bonus', comunityBonus);

  if (imageFile) {
    formData.append('image', imageFile);
  }

  try {
    const response = await axios.post(`${baseurl}/task-setting/create`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.data.status) {
      console.log('Success:', response.data);
      alert('Asset added successfully!');
      // Optionally reset state here
    } else {
      console.error('Error:', response.data.message);
    }
  } catch (error) {
    console.error('Upload failed:', error);
    alert('Upload failed. Check console.');
  }
};



const uploadImage = async () => {
    if (!imageFile) {
      alert("Please select an image first");
      return;
    }

    const formData = new FormData();
    formData.append('task_id', assetId);
    formData.append("task_image", imageFile);

    try {
      const response = await axios.post(`${baseurl}/update-task-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${authToken}`
        }
      });

      if (response.data.status) {
        alert("Image uploaded successfully");
        // You can also reset preview or close modal here
      } else {
        alert("Upload failed: " + response.data.message);
      }
    } catch (error) {
      console.error("Upload error", error);
      alert("An error occurred during upload.");
    }
  };



  return (
    <>
      <Header>
        <Auth onProfileDataFetched={handleProfileDataFetched} />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Task Setting!</h4>

              </div>
              <div className="text-end">
                <button className='btn btn-success btn-sm' data-bs-toggle="modal" data-bs-target="#addAssetModal" >+ Add Asset</button>
              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL TASK</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total : '0'}

                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>


              <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">CLOSED TASK</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.close : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE TASK</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.active : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
            </div>


            {/* row opened */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">Asset List</h3>
                  </div>
                  <div className="table-responsive country-table">
                    {tabelLoading ? (
                      <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                        <thead>
                          <tr>
                            <th className="wd-lg-25p">Rank</th>
                            <th className="wd-lg-25p">Name</th>
                            <th className="wd-lg-25p">Balance</th>
                            <th className="wd-lg-25p">Active team</th>
                            <th className="wd-lg-25p">Daily Task</th>
                            <th className="wd-lg-25p">Daily Profit</th>
                            <th className="wd-lg-25p">Show Percentage</th>
                            <th className="wd-lg-25p">Comunity Bonus</th>
                            <th className="wd-lg-25p">Upline Bonus</th>
                            <th className="wd-lg-25p">Status</th>
                          </tr>
                        </thead>

                        <tbody>
                          {assets.length > 0 ? (
                            assets.map((depositData, index) => (
                              <tr key={index}>
                                <td><span className="avatar avatar-xm avatar-rounded"> <img className="rouned" src={depositData.task_image || ""} width={30} /><a href="javascript:void(0);" onClick={() => setAssetId(depositData.id)} className="badge rounded-pill bg-primary avatar-badge profile-edit" data-bs-toggle="modal" data-bs-target="#exampleModal" ><i className="fe fe-camera" /></a></span></td>
                                <td> {depositData.task_name || 'N/A'} </td>
                                <td> ${depositData.required_from_balance || '0'}- ${depositData.required_to_balance || 'N/A'} </td>
                                <td> {depositData.required_downline || '0'} </td>
                                <td> {depositData.daily_task || '0'}</td>
                                <td> {depositData.daily_profit_percentage || '0'}% </td>
                                <td> {depositData.daily_percentage_show || '0'}% </td>
                                <td> {depositData.community_bonus || '0'}% </td>
                                <td> {depositData.upline_bonus || '0'}% </td>
                                <td>
                                  {depositData && depositData.status
                                    ? depositData.status === 'active' ? (
                                      <span className="badge bg-success">{depositData.status}</span>
                                    ) : (
                                      <span className="badge bg-danger">{depositData.status} </span>
                                    ) : 'N/A'}
                                </td>
                                {/* <td>
                                  <a data-bs-effect="effect-scale" data-bs-toggle="modal" href="#modaldemo8" className="btn btn-sm btn-warning" >
                                    <i className="fa fa-edit"></i>
                                  </a>
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    )}


                  </div>
                  <div class="gridjs-footer">
                    <div class="gridjs-pagination">
                      <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                      <div className="gridjs-pages text-end">
                        {/* Previous Button */}
                        <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                        {/* First Page */}
                        <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                        {/* Ellipsis if needed */}
                        {pagination.current_page > 3 && <span>...</span>}

                        {/* Middle Pages (2 dynamic pages around current) */}
                        {Array.from({ length: 5 }, (_, i) => {
                          const page = pagination.current_page - 2 + i;
                          if (page > 1 && page < pagination.last_page) {
                            return (
                              <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                {page}
                              </button>
                            );
                          }
                          return null;
                        })}

                        {/* Ellipsis if needed */}
                        {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                        {/* Last Page */}
                        {pagination.last_page > 1 && (
                          <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                            onClick={() => handlePageChange(pagination.last_page)}>
                            {pagination.last_page}
                          </button>
                        )}

                        {/* Next Button */}
                        <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /row */}

          </div>
        </div>

        <div className="modal fade" id="addAssetModal" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title" id="addAssetModalLabel">Add Rank</h6>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12 mt-4">
                    <label className="form-label">Rank Name</label>
                    <input type="text" className="form-control" value={rankName} onChange={(e)=>setRankName(e.target.value)} name="rankName" placeholder="Enter Rank Name" defaultValue="0" />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Required From Balance</label>
                    <input type="number" className="form-control" name="requiredFromBalance"  value={fromAmount} onChange={(e)=>setFromAmount(e.target.value)} placeholder="Enter Required From Balance" defaultValue="0"  />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Required To Balance</label>
                    <input type="number" className="form-control" name="requiredToBalance"  value={toAmount} onChange={(e)=>setToAmount(e.target.value)} placeholder="Enter Required To Balance" defaultValue="0"  />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Required Downline</label>
                    <input type="number" className="form-control" name="requiredDownline"  value={downline} onChange={(e)=>setDownline(e.target.value)} placeholder="Enter Required Downline" defaultValue="0" />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Daily Task</label>
                    <input type="text" className="form-control" name="dailyTask"  value={dailyTask} onChange={(e)=>setDailyTask(e.target.value)} placeholder="Enter Daily Task" defaultValue="0" />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Daily Profit %</label>
                    <input type="text" className="form-control" name="dailyProfitPercent"  value={dailyProfit} onChange={(e)=>setDailyProfit(e.target.value)} placeholder="Enter Daily Profit %" defaultValue="0" />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Show Profit Percentage</label>
                    <input type="text" className="form-control" name="showProfitPercent"   value={showPercentage} onChange={(e)=>setShowPercentage(e.target.value)} placeholder="Enter Show Profit %" defaultValue="0" />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Upline Bonus %</label>
                    <input type="text" className="form-control" name="uplineBonus"  value={uplineBonus} onChange={(e)=>setUploneBonus(e.target.value)} placeholder="Enter Upline Bonus %" defaultValue="0" />
                  </div>

                  <div className="col-md-6 mt-4">
                    <label className="form-label">Community Bonus %</label>
                    <input type="text" className="form-control" name="communityBonus"  value={comunityBonus} onChange={(e)=>setCommunityBonus(e.target.value)} placeholder="Enter Community Bonus %" defaultValue="0" />
                  </div>
                  <div className="col-md-12 mt-4">
                    <label className="form-label">Upload Image</label>
                    <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e)}/>
                  </div>

                  {previewImage && (
                    <div className="col-md-12 mt-3 text-center">
                      <img src={previewImage} alt="Preview" className="img-thumbnail" style={{ maxHeight: '200px' }}/>
                    </div>
                  )}

                  <div className="col-md-12 mt-4 text-end">
                    <button type="submit" className="btn btn-success" onClick={handleSubmit}>Submit</button>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>


        <div className="modal fade" id="exampleModal" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title" id="exampleModalLabel1">Upload Asset Image</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                     <div className="col-md-12 mt-4">
                    <label className="form-label">Upload Image</label>
                    <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e)}/>
                  </div>

                  {previewImage && (
                    <div className="col-md-12 mt-3 text-center">
                      <img src={previewImage} alt="Preview" className="img-thumbnail" style={{ maxHeight: '200px' }}/>
                    </div>
                  )}

                  <div className="mt-4 col-12">
                    <button className="btn btn-sm btn-success" onClick={uploadImage}>Upload Image</button>

                  </div>
                    </div>


                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger"
                            data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>


        <ToastContainer />
      </Header>


      <Footer />

    </>
  )
}

export default Tasksetting